import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { COLORS, COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

import browserBarSvg from 'assets/images/pdp/browser-bar.svg';

import { CheckmarkIcon } from '@zola/zola-ui/src/components/SvgIcons/Checkmark';
import { ChipContainer } from '@zola/zola-ui/src/components/Chip/Chip.styles';
import { Tooltip } from '@zola/zola-ui/src/components/Tooltip';
import { FooterWrapper } from '@zola/zola-ui/src/components/PreAuthV3/PreauthFooterV3.styles';
import { Section } from '@zola/zola-ui/src/components/SEORelatedLinks/SEORelatedLinks.styles';

export const Page = styled.div`
  ${FooterWrapper} {
    margin-left: auto;
    margin-right: auto;

    ${MEDIA_QUERY.DESKTOP} {
      max-width: 1920px;
      border-left: 1px solid ${COLORS3.BLACK_030};
      border-right: 1px solid ${COLORS3.BLACK_030};
    }
  }
`;

export const ThemesPdpContainer = styled.div<{
  isPostAuthNav3?: boolean;
}>`
  display: flex;
  flex-direction: column;
  max-width: 1300px;
  margin: ${SPACING.MD} auto ${SPACING.LG};
  overflow: hidden;
  padding-right: 1440px;

  ${MEDIA_QUERY.MOBILE} {
    flex-wrap: wrap;
    padding-left: ${SPACING.MD};
    padding-right: ${SPACING.MD};
  }
  ${MEDIA_QUERY.TABLET} {
    padding-left: ${SPACING.S32};
    padding-right: ${SPACING.S32};
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding-left: ${props => (props.isPostAuthNav3 ? '114px' : `${SPACING.LG}`)};
    padding-right: ${SPACING.LG};
  }
`;

export const SplitSection = styled.section`
  display: flex;
  flex-direction: row;
  padding-top: ${SPACING.MD};
  overflow: hidden;
  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column-reverse;
  }
`;
export const WebsitePreview = styled.div<{
  activeLayout?: string;
}>`
  width: 100%;
  margin-bottom: ${SPACING.S24};
  ${MEDIA_QUERY.TABLET} {
    width: 50%;
  }
  ${MEDIA_QUERY.DESKTOP} {
    width: 58%;
  }
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding-right: ${p => (p.activeLayout ? '100px' : SPACING.MD)};
    ${props =>
      props.activeLayout === 'SINGLE_PAGE' &&
      `
      height: 445px;
      overflow: hidden;
    `};
  }
  img {
    border: 1px solid ${COLORS3.BLACK_015};
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    display: block;
    max-width: 100%;
    width: 100%;

    ${MEDIA_QUERY.MOBILE} {
      ${`width: calc(100vw - ${SPACING.LG})`}
    }
  }
`;
export const PageDetails = styled.div`
  width: 42%;
  ${MEDIA_QUERY.TABLET} {
    width: 50%;
  }
  ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`;

export const Circle = styled.span`
  border-radius: 50%;
  background-color: ${COLORS.EVERGREEN};
  height: ${SPACING.S16};
  width: ${SPACING.S16};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
`;

export const StyledCheckmarkIcon = styled(CheckmarkIcon)`
  color: ${COLORS.WHITE};
  height: 9px;
  margin-bottom: 2px;
`;

export const ThemeTitle = styled.h3`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  margin: ${SPACING.XS} 0;
  display: flex;
  align-items: center;
  [class^='tagV2__'] {
    margin: 0 0 0 ${SPACING.XS};
  }

  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_LARGER)};
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SERIF};
  letter-spacing: -0.04em;
  margin: 0 0 ${SPACING.S16} 0;
`;

export const Dek = styled.p`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  color: ${COLORS3.BLACK_075};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  margin: 0;
`;

export const Color = styled.h4`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.MEDIUM};
  margin: 0 0 ${SPACING.SM} 0;
`;

export const ActionButtons = styled.div`
  a:first-of-type,
  button:first-of-type {
    margin: 0 ${SPACING.S16} ${SPACING.S16} 0;
  }

  margin: 36px 0 ${SPACING.LG} 0;

  button,
  a {
    margin-bottom: 0;

    ${MEDIA_QUERY.MOBILE} {
      margin-bottom: ${SPACING.S16};
    }
  }
`;

export const tagMargin = css`
  margin: ${SPACING.XS} 0 ${SPACING.S16};
`;

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: 246px;
  ${MEDIA_QUERY.TABLET} {
    min-height: 216px;
  }
  margin: 0 0 ${SPACING.MD};
  ${MEDIA_QUERY.MOBILE} {
    ${`width: calc(100vw - ${SPACING.LG})`};
  }

  // This is a bit of a hack for now.  This whole carousel should be rewritten for SSR compatability.
  .arrow-button--left {
    background-image: url('data:image/svg+xml;base64,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') !important;
  }

  .arrow-button--right {
    background-image: url('data:image/svg+xml;base64,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') !important;
  }

  .arrow-button--left,
  .arrow-button--right {
    background-size: contain !important;
  }

  .related-cards-carousel__content {
    margin-bottom: 0;

    button.slick-prev::before,
    button.slick-next::before {
      display: none !important;
    }
  }


  .related-cards-carousel__title {
    color: ${COLORS.BLACK};
    ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)}
    font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
    margin: 30px 0;
    ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
      margin: 0 0 30px;
    }
    text-align: center;
  }

  .is-mobile {
    &.last-section {
      margin-bottom: -50px;
    }

    .related-cards-carousel {
      margin-bottom: 0;
    }

    .related-cards-carousel__section {
      border-bottom: none;
    }
  }

  .listing-detail {
    margin: 0;
    min-height: 0;
    text-align: center !important;
    :hover {
      cursor: pointer;
    }
    .link:hover {
      text-decoration: none;
    }

    .image {
      padding-bottom: ${SPACING.XS};
      display: flex;
      justify-content: center;
      align-items: center;
      height: 110px;
      ${MEDIA_QUERY.MOBILE} {
          height: 200px;
        }
      img {
        max-height: 90px;
        ${MEDIA_QUERY.MOBILE} {
          max-height: 200px;
        }
        padding: 0;
      }
    }

    .product-name {
      ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALLER)}
      font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
      color: ${COLORS.BLACK};
    }

    .product-pricing {
      ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALLER)}
      color: ${COLORS.RED_MESSAGING};
    }
  }

  .related-cards-carousel__content {
    .slick-list {
      min-height: 0;
      overflow: hidden;
      width: 100%;
    }
  }

  .slick-slide img {
    display: block;
    max-height: 160px;
    display: block;
    max-width: 100%;
  }

  .listing-detail:hover {
    .product-name {
      color: ${COLORS.LINK_HOVER} !important;
    }
  }
`;

export const SwatchContainer = styled.div`
  padding-left: 3px;
`;

export const onlyMobile = css`
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: none;
  }
`;

export const notMobile = css`
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
`;

export const SiteLayoutContainer = styled.div`
  margin: ${SPACING.LG} 0 ${SPACING.S32} 0;
`;

export const SiteLayoutHeader = styled.p`
  ${FONT.textSizeRegular(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_100};
  font-weight: ${FONT.WEIGHT.MEDIUM};
  margin: 0 0 ${SPACING.XS} 0;
`;

export const SiteLayoutActionsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;

  ${ChipContainer} {
    align-items: center;
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;

    svg {
      margin-right: ${SPACING.SM};
    }
  }
`;

export const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: -10px;
  left: 10px;
  transform: translateY(-100%);
`;

export const SPChipContainer = styled.div<{ btnIsDisabled?: boolean }>`
  cursor: pointer;
  position: relative;
  margin-right: ${SPACING.SM};

  ${props =>
    props.btnIsDisabled &&
    `
      button {
        border-color: ${COLORS3.BLACK_030};
        color: ${COLORS3.BLACK_030};

        &:hover, &:focus, &:active {
          border-color: ${COLORS3.BLACK_030};
          color: ${COLORS3.BLACK_030};
        }
      }
    `};
`;

export const BrowserBar = styled.div`
  background-image: url(${browserBarSvg});
  height: 17px;
  width: 100%;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 4px 4px 0px 0px;
`;

export const MobileBreadcrumbsFooter = styled.div`
  padding: 24px;
  border-top: 1px solid ${COLORS3.BLACK_030};
  ${MEDIA_QUERY.NOT_MOBILE} {
    display: none;
  }
`;

export const RelatedLinksFooter = styled.div`
  ${Section} {
    margin-top: 0;
  }
`;
